import { url } from "../utils/config";
import Table from "../reusable_components/Table";
import { useEffect, useState } from "react";
import Button from "../reusable_components/Button";
import { btnOne, title } from "../utils/style";
import FleetInvoicePreview from "./FleetInvoicePreview";
import { toast } from "react-toastify";
import fetchData from "../custom_functions/fetchData";
import { formatDate } from "../helperFunctions/estimateCalculation"
import formatNumberToUs from "../custom_functions/formatNumberToUs";
import FleetStatementPreview from "./FleetStatementPreview";

function FleetInvoice() {
    const [showForm, setShowForm] = useState(false)
    const [reloadTable, setReloadTable] = useState(false)
    const [selectedRows, setSelectedRows] = useState([])
    const [showPreview, setShowPreview] = useState(false)

    const options = [
        {
            header: "Invoice Id",
            key: "id",
            width: "20%",
            render: (data) => { return `INV0000${data.id}` },
        },
        {
            header: 'Customer',
            key: "customer",
            render: (data) => { return data.fleet_customer.name },
            width: "20%",
        },
        {
            header: 'Status',
            key: 'status',
            width: "20%",
        },
        {
            header: 'Cost',
            key: 'cost',
            render: (data) => { return data.totalCost === 0 ? "$0.00" : data.invoiceType === 'fleet_manager' ? `$${formatNumberToUs(data.cost)}` : `$${formatNumberToUs(data.totalCost / 100)}` },
            width: "20%",
        },
        {
            header: 'Created At',
            key: 'date',
            placeHolder: 'mm-dd-yyyy',
            render: (data) => { return formatDate(data.date) },
            width: "20%",
        },
    ]

    const excludeFilter = ["Cost"]


    const validateCustomer = (selectedRows) => {
        const customerId = selectedRows[0].fleet_customer.id;
        return selectedRows.every(estimate => estimate.fleet_customer.id === customerId);
    }

    const handlePreview = () => {
        if (selectedRows.length === 0) {
            return toast.error("No Invoice selected.", { autoClose: 3000 });
        }
        const isCustomerValid = validateCustomer(selectedRows);
        if (!isCustomerValid) {
            return toast.error("Please select work orders with the same customer.", { autoClose: 3000 });
        } else {
            setShowPreview(true)
        }
    }
    const multiSelectedKeyPair = [{ key: "status", value: "Paid" },{key:"status", value:"Canceled"}, {key:"status", value:"Draft"}]

    return (
        <div className="overflow-y-auto">
            {showPreview &&
                <FleetStatementPreview
                    setShowPreview={setShowPreview}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    setReloadTable={setReloadTable}
                    reloadTable={reloadTable}
                />
            }
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Fleet Invoice</div>
                <div>
                    <Button className={btnOne} name={'Generate Summary'} clickHandler={() => handlePreview()} />
                </div>
            </div>
            <Table
                className="max-h-[80vh] overflow-y-auto"
                options={options}
                url={url + '/fleet_invoices'}
                pagination
                clickHandler={() => setShowForm(!showForm)}
                reloadTable={reloadTable}
                noButton={true}
                isMultiSelect={true}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                excludeFilter={excludeFilter}
                multiSelectedKeyPair={multiSelectedKeyPair}
            />
        </div>
    )
}

export default FleetInvoice;